import React from "react";

const BookingsProfileSectionIcon = () => {
  return (
    <svg
      width="22"
      height="25"
      viewBox="0 0 22 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5367 12.2956L15.2411 11L9.27667 16.9644L6.68556 14.3733L5.39 15.6689L9.27667 19.5556L16.5367 12.2956ZM19.5556 2.44444H18.3333V0H15.8889V2.44444H6.11111V0H3.66667V2.44444H2.44444C1.09389 2.44444 0.0122222 3.53833 0.0122222 4.88889L0 22C0 23.3506 1.09389 24.4444 2.44444 24.4444H19.5556C20.9061 24.4444 22 23.3506 22 22V4.88889C22 3.53833 20.9061 2.44444 19.5556 2.44444ZM19.5556 22H2.44444V8.55556H19.5556V22Z"
        fill="black"
      />
    </svg>
  );
};

export default BookingsProfileSectionIcon;
